/*

    Dev notes:
    The showPricesPinned option renders the prices pinned to the bottom
    of the thumb container. We still render the inline positioned prices
    to make space for the absolute position prices.

    Features:
        - display the product image
        - display product tag (for example sativa, indica has or whatever) in the top left corner
        - display the locations
        - display prices
            - option to pin the prices to the bottom of the menu card
        - display promotional headline
        - display effects
        - display medical attributes
        - display the new|on sale\ on clearance banner in the top right corner
*/

var BaseViews = require('../../base');
require('./menu-item-thumb/menu-item-thumb.scss');
var MenuItemPrices = require('./menu-item-prices');
var AvailableAtLocations = require('./available-at-locations');
var PotencyDisplay = require('./potency-display');
var FavouriteButton = require('./favourite-button');

var DropdownList = require('treeline-shared-components/dropdown-list/dropdown-list.js');
var MenuItemThumb = BaseViews.LayoutView.extend({
    // Only display a product tag for a product with a
    // category in _DISPLAY_PRODUCT_TAG_FOR_CATEGORIES
    _DISPLAY_PRODUCT_TAG_FOR_CATEGORIES: ['hash', 'cbd'],
    _preloadQueue: null,
    _menuState: null,
    className:
        'fmcy-menu-item-thumb hidden',
    template: require('./menu-item-thumb/menu-item-thumb.html'),
    regions: {
        pricesRegion: '.fmcy-item-prices-region',
        pricesPinnnedRegion: '.fmcy-item-prices-pinned-region',
        thumbImageRegion: '.fmcy-menu-item-thumb-image-region',
        availableAtLocationsRegion: '.fmcy-available-at-locations-region',
        vendorIconRegion: '.fmcy-vendor-icon-region',
        favouriteButtonRegion: '.fmcy-favourite-button-region',
        tagBarRegion: '.fmcy-tag-bar-region',
        locationsDdlRegion: '.fmcy-location-change-drop-down-region',
        potencyRegion: '.fmcy-potency-region'
    },
    events: {
        'click .fmcy-thumb-item-click-area': 'onClick',
        'click .fmcy-menu-item-banner': 'onClick',
        'click @ui.vendorIcon': 'onVendorClick'
    },
    ui: {
        thumbTitle: '.fmcy-menu-item-thumb-title',
        thumbInner: '.fmcy-menu-item-thumb-inner',
        thumbImage: '.fmcy-menu-item-thumb-image',
        strainTitleRow: '.fmcy-menu-item-strain-title-row',
        effectsRow: '.fmcy-menu-item-thumb-effects-row',
        medicalRow: '.fmcy-menu-item-thumb-medical-row',
        headLineRow: '.fmcy-menu-item-promotion-headline-row',
        pricesRow: '.fmcy-menu-item-thumb-prices-row',
        vendorIcon: '.fmcy-vendor-icon-region',
        clickOverlay: '.fmcy-thumb-item-click-area'
    },
    onClick: function() {
        this.trigger('thumb:clicked');
    },
    initialize: function (options) {
        var self = this;
        self.options = _.defaults(
            options || {},
            {
                theme: 'default', // default || alpha
                extraClassName: null,
                _menuState: null,
                animationStyleShow: 'long',
                animate: false,
                showProductImage: true,
                noImageAvailableIcon: require('./menu-item-thumb/img/no-image-available.png'),
                imagePreloading: true,
                imagePreloadTimeout: 60000, // 1 minute in ms
                onlinePurchaseEnabled: false,
                bannerPriority: self._DEFAULT_BANNER_PRIORITY_ORDER_FIELD_NAMES,
                showEffects: true,
                showMedicalAttrs: true,
                showStrainIcon: true,
                showStrainInEffectsRow: false,
                showPromotionHeadline: true,
                showPricesLast: false,
                showPricesPinned: false,
                menuItemPriceLayoutSinglePrice: undefined,
                menuItemPriceLayout: undefined,
                menuItemPricesTheme: undefined,
                showTitleOverProductImage: false,
                showProductLocations: false,
                showOnlineProductLocations: false,
                showTopRightBanners: true,
                showProductTag: false,
                locationSwitchingEnabled: true,
                productTagClassName: '',
                productTag: '',
                showInStoreOnlyIcon: true,
                showTopLeftSaleBanner: false
            }
        );

        if (self.options.imagePreloading) {
            var createjs = require('preload-js');
            createjs.LoadQueue.loadTimeout = self.options.imagePreloadTimeout;
            self._preloadQueue = new createjs.LoadQueue(false);
        }
        this._menuState = this.options._menuState;
    },
    _getProductTag: function () {

      var strainGroup = this.model.getStrainGroupCode();
      if (this.options.productTag) {
        return this.options.productTag;
      } else if (this.model.get('promotion_headline') && !this.model.isOnClearance() && this.model.get('promotion_headline').toLowerCase() !== 'clearance' && this.model.get('promotion_headline').toLowerCase() !== 'weekly') {
        return this.model.get('promotion_headline');
      } else if (strainGroup) {
          return strainGroup;
      } else {
          var productTag = '';
          var categorySlug;
          var x = 0;
          var categories = this.model.get('categories');
          var categoriesArr;
          if (categories instanceof Backbone.Collection) {
            categoriesArr = categories.toJSON();
          } else {
            categoriesArr = categories;
          }
          while (x <= this._DISPLAY_PRODUCT_TAG_FOR_CATEGORIES.length - 1 && !productTag) {
              categorySlug = this._DISPLAY_PRODUCT_TAG_FOR_CATEGORIES[x];
              if (_.findWhere(categoriesArr, { slug: categorySlug })) {
                  productTag = categorySlug;
              }
              x++;
          }
          return productTag;
      }
    },
    serializeData: function() {
        var self = this;
        var productTag = self._getProductTag();
        var productTagClassName;
        if (this.options.productTagClassName) {
            productTagClassName = this.options.productTagClassName;
        } else if (productTag) {
            productTagClassName = productTag;
        }

        var strain = this.model.get('strain');
        if (strain) {
          strain = strain.toUpperCase();
        }

        var nameContainsStrainName = false;
        if (this.model.get('itemName').toUpperCase().indexOf(strain) !== -1) {
          nameContainsStrainName = true;
          // hide strain if the strain name is alread within the title...
          strain = false;
        }

        return {
            options: this.options,
            itemName: self.model.get('itemName'),
            itemDescription:
                self.model.get('itemDescriptionHtml') ||
                self.model.get('itemDescription') ||
                '',
            strain: self.model.getStrainGroupCode() || '',
            productTag: productTag,
            productTagClassName: productTagClassName,
            rating: self.model.get('rating') || 0,
            productLabResults: this.model.get('lab_results'),
            strainName: strain,
            effectsAttrs: this.getEffectsAttrsString(),
            medicalAttrs: this.getMedicalAttrsString(),
            strainTitleImgClass: this.getStrainTitleImageClassName(),
            onSale: self.onSale,
            isNew: self.model.get('is_new') === true,
            bannerClassName: self.options.showTopRightBanners ? self.getBannerClassName() : '',
            shouldRenderProductLocations: this._shouldRenderProductLocations(),
            shouldRenderPromotionHeadline: this.options.showPromotionHeadline,
            headlineText: self.model.get('promotion_headline')
        };
    },
    onVendorClick: function () {
      if (this._menuState.get('mode') === 'menu') {
        this.options.appChannel.trigger(
            'search:options:changed',
            {
                filterVendor: this.model.get('vendor').get('id')
            }
        );
      }
    },
    onRender: function() {
        var self = this;

        if (self.options.extraClassName) {
            self.$el.addClass(self.options.extraClassName);
        }


        if (self.model.isOrganic()) {
          self.$el.addClass('fmcy-product-is-organic');
        }

        if (self.model.isBCGrown()) {
          self.$el.addClass('fmcy-product-is-bc-grown');
        }

        if (self.model.isFarmExclusive()) {
          self.$el.addClass('fmcy-product-is-farm-exclusive');
        }

        if (self.model.isVegan()) {
          self.$el.addClass('fmcy-product-is-vegan');
        }

        if (self.model.isHighCBD()) {
          self.$el.addClass('fmcy-product-high-cbd');
        }

        if (self.model.isHighCBNCBG()) {
          self.$el.addClass('fmcy-product-high-cbn-cbg');
        }

        var strain = self.model.getStrainGroupCode();
        if (strain) {
            self.$el.addClass(strain);
        }

        if (self.options.showPricesPinned) {
            self.$el.addClass('fmcy-menu-item-thumb-prices-pinned');
        }

        if (self.options.showTitleOverProductImage) {
            self.$el.addClass('fmcy-menu-item-thumb-title-displayed-over-product-image');
        }

        self.$el.addClass('fmcy-menu-item-thumb-theme-' + self.options.theme);

        if (self.model.isOnSale()) {
            self.$el.addClass('fmcy-menu-item-thumb-on-sale');
        }


        if (this.model.get('itemName')) {
            this.$el.removeClass('hidden');
        }

        var vendor = this.model.get('vendor');

        if (vendor) {
          var brandIcon = new (require('../../product-tile/image-display'))({
            imageURL: vendor.get('image_medium_url_' + this.model.get('theme') + '_theme'),
            displayNoImageAvailableIcon: false
          });
          brandIcon.$el.addClass('fmcy-vendor-icon');
          this.vendorIconRegion.show(brandIcon);
        }

        if (this._menuState.get('mode') !== 'menu') {
          this.ui.vendorIcon.css('pointer-events', 'none')
        }

        if ((this._menuState.get('mode') == 'menu' && this._menuState.get('isUserLoggedIn')) || (this._menuState.get('mode') == 'embedded' && this._menuState.get('isUserLoggedIn'))) {
          self.options.appChannel.request('is:favourite', self.model).then(function (response) {
            self.favouriteButton = new FavouriteButton({
              isFavourite: response
            });
            self.favouriteButton.on('toggle:favourite', function (isFavourite) {
              self.model.set('isFavourite', isFavourite);
              self.options.appChannel.request('toggle:favourite', self.model, isFavourite).then(function (response) {
                //do nothing for now? Show loader?
              });
            });
            self.favouriteButtonRegion.show(self.favouriteButton);
          });
          this.listenTo(this.options.appChannel, 'update:favourite:' +  this.model.get('id'), function (isFavourite) {
            if (self.favouriteButton) {
              self.favouriteButton.setFavourite(isFavourite);
            }
          });
        }

        if (this.model.get('theme') === 'dark') {
          this.$el.addClass('fmcy-product-tile-theme-dark');
        }
        this.ui.strainTitleRow.hide();
        this.ui.effectsRow.hide();
        this.ui.medicalRow.hide();
        this.ui.headLineRow.hide();

        this._renderPrices();
        this._maybeRenderThumbImage();
        this._maybeRenderAvailableAtLocations();
        this._maybeRenderLocationsDropdownList();
        this._renderPotency();

        if (this._shouldRenderTagBar()) {
          this.$el.addClass('fmcy-product-tile-showing-tag-bar');
          this.tagBarRegion.show(
            new (require('../../product-tile/tag-bar'))({
              showOnSaleTag: this.model.isOnSale(),
              showOnClearanceTag: this.model.isOnClearance(),
              productTagText: this._getProductTag(),
              showCBDTag: this.model.isHighCBD(),
              showCBNCBGTag: this.model.isHighCBNCBG(),
              showBcGrownTag: this.model.isBCGrown(),
              showFarmExclusiveTag: this.model.isFarmExclusive(),
              showOrganicTag: this.model.isOrganic(),
              showVeganTag: this.model.isVegan()
            })
          );
        }

        this.showThumb();


        if (!this.options.onlinePurchaseEnabled) {
          this.ui.clickOverlay.css('bottom', '0px');
        }
    },
    _shouldRenderTagBar: function () {
      return this.model.isOnSale() || this.model.isOnClearance() || this.model.isOrganic() || this.model.isVegan() || this.model.isBCGrown() || this.model.isFarmExclusive() || this.model.isHighCBD() ||  this.model.isHighCBNCBG() || this._getProductTag();
    },
    _renderPotency: function () {
      this.potencyRegion.show(
          new PotencyDisplay({
            model: this.model,
            filterLocation: this.options.appChannel.request('get:filter:location')
          })
      );
    },
    _renderPrices: function () {
        var hideOutOfStockVariations = true;
        if (this.options.onlinePurchaseEnabled) {
          hideOutOfStockVariations = false;
        }
        var pricesOptions = {
            onlinePurchaseEnabled: this.options.onlinePurchaseEnabled,
            menuItemModel: this.model,
            collection: this.model.get('variants'),
            hideDoubleZeros: false,
            hideOutOfStockVariation: hideOutOfStockVariations,
            filterLocation: this.options.appChannel.request('get:filter:location'),
            onSale: this.model.isOnSale(),
            appChannel: this.options.appChannel
        };

        if (this.options.menuItemPriceLayout) {
            pricesOptions.menuItemPriceLayout = this.options.menuItemPriceLayout;
        }

        if (this.options.menuItemPriceLayoutSinglePrice) {
            pricesOptions.menuItemPriceLayoutSinglePrice = this.options.menuItemPriceLayoutSinglePrice;
        }

        if (this.options.menuItemPricesTheme) {
            pricesOptions.theme = this.options.menuItemPricesTheme;
            this.$el.addClass('fmcy-menu-item-thumb-prices-theme-' + this.options.menuItemPricesTheme);
        }
        this.showChildView(
            'pricesRegion',
            new MenuItemPrices(pricesOptions)
        );

        if (this.options.showPricesPinned) {
            this.showChildView(
                'pricesPinnnedRegion',
                new MenuItemPrices(pricesOptions)
            );
        }
    },
    _maybeRenderLocationsDropdownList: function () {
        if (this.options.locationSwitchingEnabled === false) {
          return;
        }
        var self = this;
        var filterLocation = this.options.appChannel.request('get:filter:location');
        var locations = self.options.appChannel.request('get:locations');
        var selectedLocationModel = locations.findWhere({ slug: filterLocation});

        locations = new Backbone.Collection(locations.filter(function (model) {
          if (model.get('slug') === filterLocation || (parseInt(model.get('temp_closed')) === 1 || model.get('temp_closed') == true)) {
            return false;
          } else {
            return true;
          }
        }));

        self.locationsDdlRegion.show(
            new DropdownList({
                customClassName: 'fmcy-sort-options',
                dropdownCssClass: 'fmcy-sort-options-dropdown',
                collection: locations.toJSON(),
                displayAttr: 'name',
                placeholder: 'VIEWING ' + selectedLocationModel.get('name'),
                valueAttr: 'slug',
                suppressSearch: true,
                onSelectedCallback: function (val) {
                    if (self._menuState.get('filterLocation') === val) {
                      return;
                    }
                    //self._menuState.set('preSearch', true);
                    self.options.appChannel.trigger(
                        'search:options:changed',
                        {
                            location: val
                        }
                    );
                }
            })
        );
    },
    _maybeRenderThumbImage: function () {
        var self = this;

        if (!self.options.showProductImage) {
            return;
        }

        function setThumbImage (imageURL) {
            self.ui.thumbImage.css(
                'background-image',
                'url(' +imageURL + ')'
            );
        }

        var displayImageURL = self.options.displayImageURL;
        if (!displayImageURL) {
            displayImageURL = self.options.noImageAvailableIcon;
        }

        if (self.options.imagePreloading) {

            self.thumbImageRegion.show(
                new (require('treeline-shared-components/spinner'))({
                    message: ''
                })
            );

            var handleFileLoadError = function (event) {
                if (!self.isRendered) {
                    return false;
                }
                if (event.item.id === self.model.id) {
                    console.log('File load error occurred: ', event);
                    self._preloadQueue.removeAllEventListeners('fileload');
                    self._preloadQueue.removeAllEventListeners('error');
                    self.thumbImageRegion.empty();
                    setThumbImage(self.options.noImageAvailableIcon);
                }
            };

            var handleFileLoaded = function(event) {
                if (!self.isRendered) {
                    return false;
                }
                if (event.item.id === self.model.id) {
                    self._preloadQueue.removeAllEventListeners('fileload');
                    self._preloadQueue.removeAllEventListeners('error');
                    self.thumbImageRegion.empty();
                    setThumbImage(event.item.src);
                }
            };

            self._preloadQueue.on('error', handleFileLoadError);
            self._preloadQueue.on('fileload', handleFileLoaded);
            self._preloadQueue.loadFile({
                id: self.model.id,
                src: displayImageURL
            });

        } else {
            setThumbImage(displayImageURL);
        }
    },
    _maybeRenderAvailableAtLocations: function () {
        if (!this._shouldRenderProductLocations()) {
            return;
        }
        this.availableAtLocationsRegion.show(
            new AvailableAtLocations({
                collection: this._getProductLocations(),
                preLocationsListText: 'available at ',
                postLocationsListText: '',
                appChannel: this.options.appChannel
            })
        );
    },
    hideThumb: function() {
      if (this.options.animate) {
        if (this.options.animationStyleShow === 'long') {
            this.$el.css({opacity: 1});
            window.gsap.to(this.$el,
            {
              opacity: 0,
              duration: 1
            });
        } else {
            window.gsap.to(this.$el,
            {
              opacity: 0,
              translateY: 50,
              duration: 0.5
            });
        }
      } else {
        this.$el.css({opacity: 0});
      }
    },
    showThumb: function() {
      if (this.options.animate) {
        switch (this.options.animationStyleShow) {
            case 'long':
              this.$el.css({opacity: 0});
              window.gsap.to(this.$el,
              {
                opacity: 1,
                duration: 1
              });
            break;
            default:
              this.$el.css({opacity: 0});
              window.gsap.to(this.$el,
              {
                opacity: 1,
                duration: 1
              }).delay(0.25);
            break;
        }
      } else {
        this.$el.css({opacity: 1});
      }
    }
});
_.extend(MenuItemThumb.prototype, require('./menu-item-mixin'));
module.exports = MenuItemThumb;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/common/menu-item-thumb.js
 **/